import { IconDefinition } from '../../types';

const EllipsisH: IconDefinition = {
  name: 'ellipsis-h',
  definition: {
    viewBox: '0 0 320 512',
    pathData:
      'M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'
  }
};

export default EllipsisH;
